import { Match, Tournament, defaultMatch, emptyTournament } from '@/views/interfaces/entities.ts';
import { TournamentState } from 'vue';
import { MutationTree } from 'vuex';

export const types = {
  UPDATE_ELEMENT: 'UPDATE_ELEMENT',
  SET_TOURNAMENT: 'SET_TOURNAMENT',
  SELECT_MATCH: 'SELECT_MATCH',
  VOTE: 'VOTE',
  RESET_MATCH: 'RESET_MATCH',
  RESET_TOURNAMENT: 'RESET_TOURNAMENT',
  SET_TOURNAMENT_SOCKET: 'SET_TOURNAMENT_SOCKET',

  SET_TRENDING: 'SET_TRENDING',
  SET_ENDED: 'SET_ENDED',
};

export const mutations: MutationTree<TournamentState> = {
  [types.UPDATE_ELEMENT](state: TournamentState) {
    state.update = !state.update;
  },
  [types.SET_TRENDING](state: TournamentState, payload: Tournament[]) {
    state.trending = payload;
  },
  [types.SET_ENDED](state: TournamentState, payload: Tournament[]) {
    state.ended = payload;
  },
  [types.SET_TOURNAMENT](state: TournamentState, payload: Tournament) {
    state.tournament = payload;
  },
  [types.SET_TOURNAMENT_SOCKET](state: TournamentState, socket: WebSocket) {
    if (state.tournamentSocket && state.tournamentSocket.constructor.name === 'WebSocket') state.tournamentSocket.close();
    state.tournamentSocket = socket;
  },
  [types.SELECT_MATCH](state: TournamentState, parentIndex: number) {
    const parent = state.tournament.positions.find((position) => position.id === parentIndex);
    if (parent && parent.leftPos && parent.rightPos) {
      const leftChild = state.tournament.positions.find(
        (position) => position.id === parent.leftPos
      );
      const rightChild = state.tournament.positions.find(
        (position) => position.id === parent.rightPos
      );
      if (leftChild === undefined || rightChild === undefined) return;
      state.match.disabled = leftChild.disabled || rightChild.disabled;
      state.match.posLeft = leftChild;
      state.match.posRight = rightChild;
      state.match.parentId = parent.id;
    }
  },
  [types.VOTE](state: TournamentState, positionId: number) {
    const position = state.tournament.positions.find((position) => position.id === positionId);
    if (position === undefined) {
      console.info(`Position ${positionId} not found.`);
      return;
    }
    position.votes += 1;
  },

  [types.RESET_MATCH](state: TournamentState) {
    state.match = <Match>JSON.parse(JSON.stringify(defaultMatch));
  },

  [types.RESET_TOURNAMENT](state: TournamentState) {
    state.tournament = <Tournament>JSON.parse(JSON.stringify(emptyTournament));
  },
};
